import { facetingAttributePrefix } from '~/src/../algoliaQueries';

export const FACETING_ATTRIBUTE_PREFIX = facetingAttributePrefix;
